import { render, staticRenderFns } from "./CheckoutAddOnCheckboxGroup.vue?vue&type=template&id=53a24540"
import script from "./CheckoutAddOnCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckoutAddOnCheckboxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports